import { playerEsnToken } from '@lucimark/shared/helpers/playerEsnDisplay'
import * as Sentry from '@sentry/vue'

/**
 * Searchable identity for Discover / Issues (Context alone is not filterable).
 * `player_id_prefix` matches Studio / overlay ESN (without `#`) via {@link playerEsnToken}.
 */
export function applyPlayerSentryIdentity(params: {
  playerId: string
  platform?: string | null
  androidIdPrefix?: string | null
  tenantHandle?: string | null
  capacityTier?: 'low' | 'mid' | 'high' | null
  lowMemoryMode?: boolean
}): void {
  const playerId = params.playerId.trim()
  if (!playerId) {
    return
  }

  const prefix = playerEsnToken({
    playerId,
    platform: params.platform,
    androidIdPrefix: params.androidIdPrefix
  }) ?? playerId

  try {
    Sentry.setUser({ id: playerId })
    Sentry.setTag('player_id', playerId)
    Sentry.setTag('player_id_prefix', prefix)

    // Filter Discover/Issues by shell: `player_platform:android` vs `player_platform:web`
    // (hybrid Media3 baseline epic #1579 / P0 #1580).
    if (params.platform != null && params.platform.trim() !== '') {
      Sentry.setTag('player_platform', params.platform.trim())
    }

    if (params.tenantHandle != null && params.tenantHandle.trim() !== '') {
      Sentry.setTag('tenant_handle', params.tenantHandle.trim())
    }
    if (params.capacityTier === 'low' || params.capacityTier === 'mid' || params.capacityTier === 'high') {
      Sentry.setTag('player_capacity_tier', params.capacityTier)
    }
    if (params.lowMemoryMode === true) {
      Sentry.setTag('player_low_memory', 'true')
    }
    else if (params.lowMemoryMode === false) {
      Sentry.setTag('player_low_memory', 'false')
    }
  }
  catch {
    /* Sentry not initialized */
  }
}
